import { ComponentType } from "@/src/type";

import {
  CardScroll,
  Carousel,
  ContactUsMRI,
  ContentBlocks,
  Footer,
  FooterSimple,
  Hero,
  HeroStats,
  ImageGalary,
  SideBySide,
  UnitDetails,
  SideBySideStats,
  Lead,
  DynamicForm,
  NestedCarousel,
  MultiCTAGroup,
  HeroRotateImg,
  PropertyUnitDetails,
  ScheduleTour,
  AvailableHomes,
  AvailableHomesFilters,
  VerticalNested,
  AvailableHomesBanner,
  InlineFrame,
} from "./component";

/**
 * all props in this should be static and not change (SSR props, etc.)
 * if parent swiper, swiper slide is needed use useSwiper or useSwiperSlide in Section component
 */
interface DynamicPageSectionProps extends ComponentType.DynamicPageSectionComponentProps<any> {
  index: number;
  extraSectionsToEagerLoad?: number;
}

function DynamicPageSection({
  section,
  slug,
  snapToGrid,
  index,
  initialSlide,
  bottomDrawerHeight,
  searchParams,
  contactUsLink,
  contactUsButtonText,
  classes,
  mobileHint,
  deviceWidthHint,
  quality,
  extraSectionsToEagerLoad,
  userAgent,
  layout,
  calendarConfig,
  sectionTypePath,
}: DynamicPageSectionProps) {
  //determine which sections/slides to eager load images
  const defaultLazyLayout = layout === "main" ? 0 : 1;
  const eagerLoad = typeof extraSectionsToEagerLoad === "number" ? extraSectionsToEagerLoad : 1 + defaultLazyLayout;
  const lazy = index <= (initialSlide ?? 0) + eagerLoad && index >= (initialSlide ?? 0) ? "eager" : "lazy";
  const sectionProps: ComponentType.DynamicPageSectionComponentProps<any> = {
    section,
    slug,
    snapToGrid,
    index,
    initialSlide,
    bottomDrawerHeight,
    searchParams,
    contactUsLink,
    contactUsButtonText,
    lazy,
    classes,
    mobileHint,
    deviceWidthHint,
    quality,
    userAgent,
    layout,
    calendarConfig,
    sectionTypePath,
  };

  //console.log(section.type?.[0]?.__component, lazy, extraSectionsToEagerLoad);
  switch (section.type?.[0]?.__component ?? "default") {
    case "section.welcome":
      return <Hero {...sectionProps} />;
    case "section.hero-stats":
      return <HeroStats {...sectionProps} />;
    case "section.content-blocks":
      return <ContentBlocks {...sectionProps} />;
    case "section.side-by-side":
      return <SideBySide {...sectionProps} />;
    case "section.side-by-side-stats":
      return <SideBySideStats {...sectionProps} />;
    case "section.card-scroll":
      return <CardScroll {...sectionProps} />;
    case "section.carousel":
      return <Carousel {...sectionProps} />;
    case "section.image-gallery":
      return <ImageGalary {...sectionProps} />;
    case "section.contact-us":
      return <ContactUsMRI {...sectionProps} />;
    case "section.lead":
      return <Lead {...sectionProps} />;
    case "section.footer":
      return <Footer {...sectionProps} />;
    case "section.unit-details":
      return <UnitDetails {...sectionProps} />;
    case "section.dynamic-form":
      return <DynamicForm {...sectionProps} />;
    case "section.nested-carousel":
      return <NestedCarousel {...sectionProps} />;
    case "section.multi-cta-group":
      return <MultiCTAGroup {...sectionProps} />;
    case "section.hero-rotate-img":
      return <HeroRotateImg {...sectionProps} />;
    case "section.footer-simple":
      return <FooterSimple {...sectionProps} />;
    case "section.schedule-tour":
      return <ScheduleTour {...sectionProps} />;
    case "section.property-unit-details":
      return <PropertyUnitDetails {...sectionProps} />;
    case "section.property-unit":
    case "section.available-home":
      return <AvailableHomes {...sectionProps} />;
    case "section.available-homes-filters":
      return <AvailableHomesFilters {...sectionProps} />;
    case "section.vertical-nested":
      return <VerticalNested {...sectionProps} />;
    case "section.available-homes-banner":
      return <AvailableHomesBanner {...sectionProps} />;
    case "section.inline-frame":
      return <InlineFrame {...sectionProps} />;
    default:
      return <></>;
  }
}

export default DynamicPageSection;
